(function () {
  const lookbook = {
    init() {
      this.$el = document.querySelector('.page_wrapper.lookbook')
      if (this.$el !== null) {
        console.log('Initializing lookbook...')
        this.sliders = []
        this.$videos = this.$el.querySelectorAll('section.lookbook video.video')

        // because this is the only way to reference it in removeEventList...
        this.scrollDownBinded = this.scrollDown.bind(this)
        this.destroyBinded = this.destroy.bind(this)

        this.setUpListeners()
        this.setUpImgSliders()
        this.setUpParallax()
        this.setUpProductSliders()
      }
    },

    setUpListeners() {
      PubSub.subscribe('page.transitionStartDone', this.destroyBinded)

      this.$el
        .querySelectorAll('button.explore')
        .forEach($btn => $btn.addEventListener('click', this.scrollDownBinded))

      if (this.$videos.length > 0) {
        this.observer = new IntersectionObserver(this.observe.bind(this))

        this.$videos.forEach($vid => {
          this.observer.observe($vid)
        })
      }
    },

    observe(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.startLoop(entry.target)
        } else {
          this.pauseLoop(entry.target)
        }
      })
    },

    startLoop($video) {
      const loadHandler = () => {
        $video.removeEventListener('loadedmetadata', loadHandler)
        $video.play()
      }

      if ($video.readyState >= 1) {
        $video.play()
      } else {
        $video.addEventListener('loadedmetadata', loadHandler)
      }
    },

    pauseLoop($video) {
      $video.pause()
    },

    scrollDown(ev) {
      gsap.to(window, {
        duration: 0.5,
        scrollTo: {
          y: ev.currentTarget.closest('.look_wrapper').querySelector('.products_wrapper')
        }
      })
    },

    setUpParallax() {
      document.querySelectorAll('.look_wrapper')
        .forEach($look => {
          gsap.to($look.querySelector('.small.tns-slide-active'), {
            y: tangleweb.currRootSize * 1,
            scrollTrigger: {
              id: 'look-parallax',
              trigger: $look.querySelector('.wrapper'),
              // end: '70%',
              scrub: true
            }
          })
        })
    },

    setUpProductSliders() {
      document
        .querySelectorAll('.products_wrapper')
        .forEach($slider => {
          this.sliders.push(tns({
            container: $slider.querySelector('.wrapper'),
            loop: true,
            preventActionWhenRunning: true,
            mouseDrag: true,
            slideBy: 1,
            autoplay: true,
            items: 3,
            autoplayButtonOutput: false,
            prevButton: $slider.querySelector('.button.prev'),
            nextButton: $slider.querySelector('.button.next'),
            disable: true,
            responsive: {
              768: {
                disable: false
              }
            }
          }))
        })
    },

    setUpImgSliders() {
      document
        .querySelectorAll('.images_wrapper')
        .forEach($slider => {
          this.sliders.push(tns({
            container: $slider.querySelector('.wrapper'),
            loop: true,
            preventActionWhenRunning: true,
            mouseDrag: true,
            slideBy: 1,
            // autoplay: true,
            autoHeight: true,
            lazyload: true,
            items: 1,
            autoplayButtonOutput: false,
            prevButton: $slider.querySelector('.button.prev'),
            nextButton: $slider.querySelector('.button.next'),
            disable: false,
            responsive: {
              768: {
                disable: false
              }
            }
          }))
        })
    },

    destroy() {
      const triggers = ScrollTrigger.getAll()
      console.log('Destroy: lookbook')

      PubSub.unsubscribe('page.transitionStartDone', this.destroyBinded)

      this.$el
        .querySelectorAll('button.explore')
        .forEach($btn => $btn.removeEventListener('click', this.scrollDownBinded))

      triggers.forEach(trigger => {
        if (trigger.vars.id === 'look-parallax') {
          trigger.kill()
          console.log('Destroying look-parallax')
        }
      })

      ScrollTrigger.refresh()

      this.sliders.forEach(slider => slider.destroy())
      this.sliders.length = 0

      if (this.observer) {
        this.observer.disconnect()
      }
    }
  }

  Object.assign(lookbook, window.tangleweb)

  lookbook.init()
  PubSub.subscribe('page.inDOM', lookbook.init.bind(lookbook))
})()
